import { render } from "./ModalUploadDocumentsMonthly.vue?vue&type=template&id=ae4aeef2&scoped=true"
import script from "./ModalUploadDocumentsMonthly.vue?vue&type=script&lang=js"
export * from "./ModalUploadDocumentsMonthly.vue?vue&type=script&lang=js"

import "./ModalUploadDocumentsMonthly.vue?vue&type=style&index=0&id=ae4aeef2&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae4aeef2"]])

export default __exports__